import ProfileTable from './ProfileTable';

export default ProfileTable;
